var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wl-container" }, [
    _c(
      "div",
      { staticClass: "wl-content-container" },
      [
        _c("div", { staticClass: "wl-search-bar" }, [
          _c(
            "div",
            { staticClass: "wl-left" },
            [
              _c("el-date-picker", {
                staticClass: "input-with-select",
                attrs: {
                  type: "daterange",
                  "range-separator": _vm.$t("SITE_TO"),
                  "value-format": "yyyy-MM-dd",
                  "start-placeholder": _vm.$t("SITE_START_DATE"),
                  "picker-options": _vm.options,
                  clearable: false,
                  "end-placeholder": _vm.$t("SITE_END_DATE"),
                },
                model: {
                  value: _vm.dateRange,
                  callback: function ($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "wl-right" },
            [
              _c(
                "el-button",
                {
                  staticClass: "wl-green svg-btn",
                  on: { click: _vm.downloadTrace },
                },
                [
                  _c("img", {
                    staticClass: "btn-icon",
                    attrs: {
                      src: require("@/assets/img/icon-export.svg"),
                      width: "100%",
                    },
                  }),
                  _vm._v(_vm._s(_vm.$t("COMMON_EXPORT")) + " "),
                ]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "table-container-wrapper" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: {
                  height: "100%",
                  data: _vm.data,
                  border: "",
                  stripe: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", width: "70" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "operUrl",
                    label: _vm.$t("AUDIT_TRAIL_TABLE_HEADER_ACCESS_URL"),
                    "show-overflow-tooltip": "",
                    width: "200",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "operIp",
                    label: _vm.$t("AUDIT_TRAIL_TABLE_HEADER_OPERATION_IP"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "userAgent",
                    "show-overflow-tooltip": "",
                    label: _vm.$t("AUDIT_TRAIL_TABLE_HEADER_USER_AGENT"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "operType",
                    label: _vm.$t("AUDIT_TRAIL_TABLE_HEADER_USER_TYPE"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "operator",
                    label: _vm.$t("AUDIT_TRAIL_TABLE_HEADER_OPERATOR"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "operLog",
                    label: _vm.$t("AUDIT_TRAIL_TABLE_HEADER_OPERATION_LOG"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "operTime",
                    label: _vm.$t("AUDIT_TRAIL_TABLE_HEADER_OPERATION_TIME"),
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("el-pagination", {
          staticClass: "wl-pagination",
          attrs: {
            "current-page": _vm.pagination.pageNum,
            "page-size": _vm.pagination.pageSize,
            "page-sizes": [10, 50, 100],
            layout: "prev, pager, next, sizes, total",
            total: _vm.pagination.total,
          },
          on: {
            "current-change": _vm.onCurrentPageChange,
            "size-change": _vm.onSizeChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }